// extracted by mini-css-extract-plugin
export var block = "result-module--block--1806f";
export var block1 = "result-module--block--1--edd78";
export var block2 = "result-module--block--2--3bf7f";
export var item = "result-module--item--4b630";
export var list = "result-module--list--ef3d8";
export var point = "result-module--point--5f6ad";
export var result = "result-module--result--a4019";